import SuperRepository from '../superRepository'

export default new (class CountryMappingRepository extends SuperRepository {
  baseUri() {
    return 'country_mapping'
  }
})()
